import React from 'react';
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  title,
  subtitle,
  tone = 'light'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-68" data-mp="3f36q7i3iln6m">
      <h2 className={`font-display text-[30px] font-bold leading-[1.12] sm:text-4xl md:text-[46px] ${dark ? 'text-white' : 'text-navy'}`} data-id="element-69" data-mp="3jzdnkmhuhqcy">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg leading-relaxed ${dark ? 'text-white/80' : 'text-muted'}`} data-id="element-70" data-mp="giewvtjwf3pi">{subtitle}</p>}
    </div>;
}